module.exports = __webpack_public_path__ + "img/icon294.823b32da.png";